import { useMemo } from 'react';
import { useTheme } from '@/components/theme/useTheme';

/**
 * Resolves theme-token CSS vars (HSL triplets) to full `hsl(...)` color strings
 * for use as Recharts color props (stroke/fill). Recomputes whenever the
 * resolved theme changes so charts stay legible across light/dark/Industrial.
 */
export function useChartColors() {
  const { resolvedTheme } = useTheme();

  return useMemo(() => {
    const v = (name: string) =>
      `hsl(${getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim()})`;

    return {
      info: v('--info'),
      success: v('--success'),
      warning: v('--warning'),
      destructive: v('--destructive'),
      muted: v('--muted-foreground'),
      border: v('--border'),
      foreground: v('--foreground'),
      card: v('--card'),
    };
    // resolvedTheme drives recomputation after the DOM theme class swaps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedTheme]);
}
